"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_system_1 = require("styled-system");
const spinner_1 = require("../spinner/spinner");
const styled_1 = __importDefault(require("../../styles/styled"));
const app_text_1 = require("../typography/app_text");
const StyledButton = styled_1.default.button(props => ({
    border: 'none',
    cursor: 'pointer',
    height: props.mobile ? '48px' : '40px',
    borderRadius: props.mobile ? '24px' : '20px',
    textAlign: 'center',
    textDecoration: 'none',
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '40px',
    paddingRight: '40px',
    ':focus:not(.focus-visible)': {
        outline: 'none',
    },
    ':disabled': {
        cursor: 'not-allowed',
    },
}), styled_system_1.layout, styled_system_1.space, styled_system_1.borderRadius, styled_system_1.buttonStyle);
const Button = (_a) => {
    var { loading, children, fontSize, variant, fontColor, light } = _a, rest = __rest(_a, ["loading", "children", "fontSize", "variant", "fontColor", "light"]);
    return ((0, jsx_runtime_1.jsx)(StyledButton, Object.assign({ variant: variant }, rest, { children: typeof children === 'function' ? (children({ loading })) : loading ? ((0, jsx_runtime_1.jsx)(spinner_1.Spinner, { size: "30px", color: variant === 'secondary' ? 'black' : 'white' })) : ((0, jsx_runtime_1.jsx)(app_text_1.ButtonAppText, Object.assign({ headingFontFamily: true, semibold: true, color: fontColor ? fontColor : 'inherit', size: fontSize, light: light }, { children: children }))) })));
};
exports.Button = Button;
exports.Button.defaultProps = {
    variant: 'primary',
    type: 'button',
};
exports.default = exports.Button;
//# sourceMappingURL=button.js.map